import apiFetch from '../../apiFetch'

export default function (idControlMorfologico, token) {
  return apiFetch({endPoint: `ControlMorfologico/eliminarControlMorfologico?idControlMorfologico=` + idControlMorfologico, method: 'GET', body: null, token: token})
}
